import { createRoutine } from 'redux-saga-routines';
import { ACTION_ERROR_MESSAGE_RESET } from '@/constants';

export default createRoutine(ACTION_ERROR_MESSAGE_RESET);
